import { useSortable } from '@dnd-kit/react/sortable';
import styled from '@emotion/styled';
import DeleteIcon from '@mui/icons-material/Delete';
import MoveIcon from '@mui/icons-material/OpenWith';
import { ButtonBase } from '@mui/material';
import { useState } from 'react';

import DeleteModal from '../DeleteModal/DeleteModal';

const SortableItem = ({
  onDelete,
  index,
  item,
  canDelete = true,
  canReorder = true,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const id = item.guid;
  const { ref } = useSortable({ id, index, disabled: !canReorder });
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };
  return (
    <>
      <List ref={ref} style={{ cursor: canReorder ? 'move' : 'default' }}>
        <Row>
          {canReorder ? <MoveIcon /> : null}
          <span>{item.display}</span>
        </Row>
        {canDelete ? (
          <Icons>
            <ButtonBase
              onMouseDown={() => {
                setIsDeleteModalOpen(true);
              }}
            >
              <DeleteIcon />
            </ButtonBase>
          </Icons>
        ) : null}
      </List>

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={closeDeleteModal}
          locationId={id}
          title={item.display}
          onDelete={onDelete}
        />
      ) : null}
    </>
  );
};

const List = styled.li`
  padding: 10px 10px;
  //border: 1px solid #737373;
  background: #f5f5f5;
  border-radius: 5px;
  list-style: none;
  display: flex;
  z-index: 100;
  align-content: center;
  justify-content: space-between;
  margin-bottom: 10px;
  cursor: move;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
`;

export default SortableItem;
